import { createLabeledMessages, slashJoin, unitJoin } from '../../../messageUtils';
const discount = {
    decisivePeriod: 'rozhodujúce obdobie',
    decisivePeriodPer: unitJoin('discount:decisivePeriod_label', 'percent'),
    bonus: 'bonus',
    malus: 'malus',
    bonusMalus: slashJoin('discount:bonus_label', 'discount:malus_label'),
    bonusMalusPer: unitJoin('discount:bonusMalus', 'percent'),
    internalCredits: 'zľava za interné kredity',
    internalCreditsPer: unitJoin('discount:internalCredits_label', 'percent'),
    businessDiscount: 'obchodná zľava',
    businessDiscountPer: unitJoin('discount:businessDiscount_label', 'percent'),
    businessDiscountKc: unitJoin('discount:businessDiscount_label', 'kc'),
    marketingAction: 'marketingová akcia',
    marketingActionPer: unitJoin('discount:marketingAction_label', 'percent'),
    marketingActionName: '$t(discount:marketingAction_label) ($t(common:name))',
    technicalInsurance: 'technické poistenie'
};
export default Object.assign({}, discount, createLabeledMessages(discount));
